/**
 * City Deck Global Constants
 */

/**
 * BATTLE_DEMO_MODE: Playtesting mode that bypasses the map
 * When true:
 * - Redirects from index.js to battle-demo.js landing page
 * - Shows 5 match type buttons instead of the map
 * - Unlocks one card after each non-tutorial battle (pick from 3 random locked cards)
 * - Still shows mythic token rewards after card selection
 */
export const BATTLE_DEMO_MODE = true;

/**
 * GOD_MODE: Enable admin testing features
 * Requires is_admin=true in database (backend validates)
 * Toggle this to switch between normal and GOD_MODE instantly across the entire app
 *
 * When GOD_MODE is ON (and user is admin):
 * - 10 energy at turn start
 * - 11 cards in hand (leaves 1 in deck to test draw abilities)
 * - All cards unlocked in deck builder
 * - Purple "GOD MODE ACTIVE" banner
 */
export const GOD_MODE = false;

/**
 * Animation durations (in milliseconds)
 */
export const ANIMATION_DURATIONS = {
  MOVEMENT: 400,
  DEPLOYMENT: 300,
  ATTACK: 400,
  CAPTURE: 400,
  CARD_DRAW: 1600,
  DEATH: 500,
  PUSH_OFF_BOARD: 400,
  DAMAGE_NUMBER: 1850,
  ENERGY_FLASH: 400,
};

/**
 * Debug: Animation slowdown multiplier
 * Set to 10+ to slow animations way down for troubleshooting
 * Default: 1 (normal speed)
 */
export const ANIMATION_DEBUG_MULTIPLIER = 1;

/**
 * Helper function to get actual animation duration with debug multiplier applied
 * @param {number} baseDuration - Base duration in milliseconds
 * @returns {number} Actual duration with multiplier applied
 */
export const getAnimationDuration = (baseDuration) => {
  return baseDuration * ANIMATION_DEBUG_MULTIPLIER;
};

/**
 * Debug: Enable/disable card draw animation
 * Set to false for faster testing (skips the card reveal animation)
 */
export const ENABLE_CARD_DRAW_ANIMATION = true;

/**
 * Debug: Show mobile log drawer
 * Set to false to hide the debug log drawer on mobile devices
 */
export const SHOW_MOBILE_LOG_DRAWER = false;

/**
 * NOTE: Turn timer is now controlled per-game via the isTimed property
 * Set when creating a game via api.createGame(userId, isAiGame, godMode, isTimed)
 * This constant has been removed in favor of per-game timer control
 */
